// extracted by mini-css-extract-plugin
export var searchHeader = "_7u-0";
export var searchHeaderDark = "_7u-1";